<template>
  <div>
    <div class="top-banner">
      {{ title }}
      <div class="user" @click="logout"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    }
  },
  data () {
    return {
      times: 0
    }
  },
  methods: {
    logout () {
      if (this.times === 2) {
        this.$confirm('确认退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.clear()
          this.$router.push('/stuLogin')
        }).catch(() => {
        })
      } else {
        this.times++
      }
    }
  }
}
</script>
<style lang="less" scoped>
.top-banner{
  width: 100%;
  height: 150px;
  background-image: url(../../../assets/img/top-bg.png);
  background-size: cover;
  background-position: center;
  text-align: center;
  line-height: 150px;
  font-size: 30px;
  font-family: regular;
  color: #fff;
  margin-bottom: 20px;
  position: relative;
}
.user{
  width: 80px;
  height: 80px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000000;
}
</style>
